import React, { useState , useContext, useEffect } from 'react'
import DataFetch from '../../Context/DataFetch';
import moment from 'moment';
import { ToastContainer, toast } from 'react-toastify';
import Language  from '../../Context/Language';




export default function TeamsInfo() {
  const [HomeJersey , setHomeJersey] = useState([])
  const [Awayersey , setAwayersey] = useState([])
  const datam = useContext(DataFetch);
  const {data , HomeLastMatchData ,AwayLastMatchData ,data1 ,data2 , Channel} = useContext(DataFetch)
  const dataLang = useContext(Language);
  const [ChannelTv , setChannelTv] = useState(false)
  const [accumulatorGr , setaccumulatorGr] = useState()
  const [ev , setev] = useState("") 
  const [German , setGerman] = useState("")


   function addDefaultSrc(ev){
    ev.target.src = '/CountryFlag/world.png'
  }

  useEffect(() => {
     if(Channel) {
      JSON.parse(Channel).map((item,i) => {
        if(item.country === "Germany"){
          setGerman("true")
        }else{
          
        }
      })
      
     }

   if(data1  || data2 ) {
    if( datam.data1.competitor_Id === datam.data.homeTeamId ) {
      setev("data1")
         setHomeJersey(JSON.parse(datam.data1.teamcolor))
         setAwayersey(JSON.parse(datam.data2.teamcolor))
      }
      else{
        setev("data2")
         setHomeJersey(JSON.parse(datam.data2.teamcolor))
         setAwayersey(JSON.parse(datam.data1.teamcolor))

      }
   }
  },[])
  



  return (
    <div className='TeamsContainerPage'>
        <div className='TeamsHeaderPage'>
            <div className='TeamsHeaderPageText'><div className='TeamsHeaderPageTextDiv'>{datam.data.seasonName}</div></div>
         </div>
        <div className='headTeamsContainer'>
        <div className='HomeTeamArea'>
            <div className="container__inner">
              {

                HomeJersey !== null  ?
                <div className="football-kit football-kit--stripes">
               <div style={{background: `repeating-linear-gradient(to right, ${HomeJersey.primary}, ${HomeJersey.primary} 10px, ${HomeJersey.secondary} 10px, ${HomeJersey.secondary} 17.5px) `}} className="football-kit__shirt"></div>
                <div style={{ background: 	`repeating-linear-gradient(to bottom, ${HomeJersey.primary}, ${HomeJersey.primary} 10px, ${HomeJersey.secondary} 10px, ${HomeJersey.secondary} 20px) `}} className="football-kit__stripes football-kit__stripes--left"></div>
                <div style={{background: ` repeating-linear-gradient(to bottom, ${HomeJersey.primary}, ${HomeJersey.primary} 10px, ${HomeJersey.secondary} 10px, ${HomeJersey.secondary} 20px)` }} className="football-kit__stripes football-kit__stripes--right"></div>
           </div>
           :
           <div className="football-kit football-kit--stripes">
           <div className="football-kit__shirt"></div>
           <div  className="football-kit__stripes football-kit__stripes--left"></div>
           <div className="football-kit__stripes football-kit__stripes--right"></div>
      </div>
              }

        </div>
        <div className='TeamContainerTextHome'><img alt='' src={`https://cdn-images.nvpark.com/logo/${datam.data.homeTeamId}.png` }  onError={addDefaultSrc} className='TeamsInfoImage' ></img><div className='TeamContainerTeamName'>{datam.data.homeTeamName}</div></div>
       
        {
               HomeLastMatchData.length !==0  ?
               <div className="containerbx">
                <div className="bx-pager bx-default-pager">
                {
                      HomeLastMatchData.map(function(item, i){ 
                         return  item.winner_Id === 0 ?

                         <div key={i} className="bx-pager-item">
                         <div className="bx-pager-link ">{dataLang[sessionStorage.getItem("lang")].D}</div>
                           <div className="arrow">
                          </div>
                        </div>

                        :
                        item.winner_Id === data.homeTeamId ?
                        <div key={i} className="bx-pager-item green">
                        <div className="bx-pager-link ">{dataLang[sessionStorage.getItem("lang")].W}</div>
                          <div className="arrow">
                         </div>
                       </div>

                       :
                       <div key={i} className="bx-pager-item red ">
                       <div className="bx-pager-link ">{dataLang[sessionStorage.getItem("lang")].L}</div>
                         <div className="arrow">
                        </div>
                      </div>

                           })
                }
                 </div>
             
                  </div> 
               :""
             }

                 <div className='ManagerPosition'>
                   <img src='/manager.png' width={17} height={17}></img>
                   {
                     data.homeTeamManager !== null ?  <div className='ManagerText'>{data.homeTeamManager}</div> : "-"
                   }
                </div>
    </div>
        <div className='TeamsTimeArea'>
            <div className='TeamsTimeDateText'>{moment(datam.data.competitionDate).format("DD/MM/YY kk:mm")}</div>
            <div className='TeamsTimeStatText'><img alt='' src='/saha.png' width={25}></img><div className='TeamsDateAltText'>{datam.data.venueId === 0 ? "-" : datam.data.venueName}</div></div>
            <div className='RefereeArea'><img alt='' width={19} height={19} src='/football-referee.png'></img><div className='RefereeTextStyle'>{datam.data.refereeId === 0 ? "-" : datam.data.mainReferee}</div></div>
             
            {
              Channel ? 
                 <div className='ChannelAREA'>
                 {
                   German === "true" ? 
                   JSON.parse(Channel).filter(name =>  name.country ==="Germany" ?  name.country :  false).map(function(item ,i) {
                     return <div id={item.country} className='ChannelTv' key={i}><img src='/television.png' width={25} height={25}></img>
                     <div className='ChannelName'>{item.name.split("-")[0]}</div>
                     <img onClick={() => setChannelTv(!ChannelTv)} src='/down.png' width={17} height={17}></img></div>
                   }
                   )
                   : 
                   
                   <div id={JSON.parse(Channel)[0].country} className='ChannelTv' key={JSON.parse(Channel)[0].country_code}><img src='/television.png' width={25} height={25}></img>
                   <div className='ChannelName'>{JSON.parse(Channel)[0].name.split("-")[0]}</div>
                   <img onClick={() => setChannelTv(!ChannelTv)} src='/down.png' width={17} height={17}></img></div>
                 }
       
                     {
                                          ChannelTv ?
                                             <div  className='OtherChannelArea'>
                                             {
                                                JSON.parse(Channel).map(function(item , i) {
                                                       return <div className='TvChannelName' key={i}><div>{item.name.split("-")[0]}</div></div>
                                               })
                                             }
                                            </div>
                                            :
                                            ""
       
                     } 
       
                  </div>
                  :
                  ""

            }


        </div>
        <div className='AwayTeamArea'>
               <div className="container__inner">
                      {
               Awayersey !==null?
                <div className="football-kit football-kit--stripes-away">
       <div style={{background: `repeating-linear-gradient(to right, ${Awayersey.primary}, ${Awayersey.primary} 10px, ${Awayersey.secondary} 10px, ${Awayersey.secondary} 17.5px) `}} className="football-kit__shirt"></div>
                <div style={{ background: 	`repeating-linear-gradient(to bottom, ${Awayersey.primary}, ${Awayersey.primary} 10px, ${Awayersey.secondary} 10px, ${Awayersey.secondary} 20px) `}} className="football-kit__stripes football-kit__stripes--left"></div>
                <div style={{background: ` repeating-linear-gradient(to bottom, ${Awayersey.primary}, ${Awayersey.primary} 10px, ${Awayersey.secondary} 10px, ${Awayersey.secondary} 20px)` }} className="football-kit__stripes football-kit__stripes--right"></div>
         </div>
           :
           <div className="football-kit football-kit--stripes-away">
           <div  className="football-kit__shirt"></div>
            <div  className="football-kit__stripes football-kit__stripes--left"></div>
           <div  className="football-kit__stripes football-kit__stripes--right"></div>
    </div>
              }
           
            </div>
            <ToastContainer />
            <div className='TeamContainerTextHome'><img alt='' src={`https://cdn-images.nvpark.com/logo/${datam.data.awayTeamId}.png` } onError={addDefaultSrc}  className='TeamsInfoImage'></img><div className='TeamContainerTeamName'>{datam.data.awayTeamName}</div></div>
            {
               HomeLastMatchData.length !==0  ?
               <div className="containerbx">
                <div className="bx-pager bx-default-pager">
                {
                      AwayLastMatchData.map(function(item, i){ 
                         return  item.winner_Id === 0 ?

                         <div key={i} className="bx-pager-item">
                         <div className="bx-pager-link ">{dataLang[sessionStorage.getItem("lang")].D}</div>
                           <div className="arrow">
                          </div>
                        </div>

                        :
                        item.winner_Id === data.awayTeamId ?
                        <div key={i} className="bx-pager-item green">
                        <div className="bx-pager-link ">{dataLang[sessionStorage.getItem("lang")].W}</div>
                          <div className="arrow">
                         </div>
                       </div>

                       :
                       <div key={i} className="bx-pager-item red ">
                       <div className="bx-pager-link ">{dataLang[sessionStorage.getItem("lang")].L}</div>
                         <div className="arrow">
                        </div>
                      </div>

                           })
                }
                 </div>
             
                  </div> 
               :""
             }

             
                
                 <div className='ManagerPosition'>
                   <img src='/manager.png' width={17} height={17}></img>
                   {
                     data.awayTeamManager !== null ?  <div className='ManagerText'>{data.awayTeamManager}</div> : "-"
                   }
                  
                </div>  
               
             



        </div>
    </div>
    </div>
  )
}
